import { each } from "fxjs/es";
import { PathEditorNS } from "../../../../../../PathEditor/PathEditorNS.js";
export const endEditPath = (self) => {
  self._checkIsPathEditing();
  each(({ view }) => view.remove())(self._path_editor_list);
  self._path_editor_target_el = null;
  self._path_editor_list = [];
  self._path_editor_point_size_controller = null;
  self._processing_task = null;
};
